import React from 'react';
import { View, TouchableOpacity, Text } from 'react-native';
import styles from '../../styles/pages/projectstatusStyles';

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

const Pagination = ({ currentPage, totalPages, onPageChange }: PaginationProps) => {
  const renderPageNumbers = () => {
    const pages = [];
    
    // 첫 페이지 표시
    if (currentPage > 3) {
      pages.push(
        <TouchableOpacity
          key={1}
          style={[styles.pageButton, currentPage === 1 && styles.activePageButton]}
          onPress={() => onPageChange(1)}
        >
          <Text style={[styles.pageText, currentPage === 1 && styles.activePageText]}>1</Text>
        </TouchableOpacity>
      );
      
      if (currentPage > 4) {
        pages.push(
          <Text key="leftDots" style={styles.pageText}>...</Text>
        );
      }
    }

    // 현재 페이지 주변 페이지들 표시
    for (let i = Math.max(1, currentPage - 2); i <= Math.min(totalPages, currentPage + 2); i++) {
      pages.push(
        <TouchableOpacity
          key={i}
          style={[styles.pageButton, currentPage === i && styles.activePageButton]}
          onPress={() => onPageChange(i)}
        >
          <Text style={[styles.pageText, currentPage === i && styles.activePageText]}>{i}</Text>
        </TouchableOpacity>
      );
    }

    // 마지막 페이지 표시
    if (currentPage < totalPages - 2) {
      if (currentPage < totalPages - 3) {
        pages.push(
          <Text key="rightDots" style={styles.pageText}>...</Text>
        );
      }
      pages.push(
        <TouchableOpacity
          key={totalPages}
          style={[styles.pageButton, currentPage === totalPages && styles.activePageButton]}
          onPress={() => onPageChange(totalPages)}
        >
          <Text style={[styles.pageText, currentPage === totalPages && styles.activePageText]}>
            {totalPages}
          </Text>
        </TouchableOpacity>
      );
    }

    return pages;
  };

  return (
    <View style={styles.paginationContainer}>
      <TouchableOpacity
        style={[styles.pageButton, currentPage === 1 && styles.disabledButton]}
        onPress={() => currentPage > 1 && onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
      >
        <Text style={[styles.pageText, currentPage === 1 && styles.disabledText]}>←</Text>
      </TouchableOpacity>

      <View style={styles.pageNumbers}>
        {renderPageNumbers()}
      </View>

      <TouchableOpacity
        style={[styles.pageButton, currentPage === totalPages && styles.disabledButton]}
        onPress={() => currentPage < totalPages && onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
      >
        <Text style={[styles.pageText, currentPage === totalPages && styles.disabledText]}>→</Text>
      </TouchableOpacity>
    </View>
  );
};

export default Pagination;